import Swiper from 'Swiper';

class Slider {
    constructor (element, options) {
        const settings = {
            autoHeight: false,
            autoplay: false,
            pauseOnHover: false,
            calculateHeight: true,
            centeredSlides: false,
            counter: false,
            crossfade: false,
            effect: 'slide',
            equalHeights: false,
            fractionText: '/',
            freeMode: false,
            freeModeSticky: false,
            fullscreen: false,
            fullscreenAttr: 'fullscreen',
            indicators: false,
            indicatorsInControls: true,
            indicatorsHover: false,
            initAttr: 'data-slider',
            initialSlide: 0,
            lazyLoading: false,
            longSwipesRatio: 0.0025,
            loop: false,
            loopedSlides: null,
            mousewheel: false,
            parallax: false,
            prevnext: true,
            resistanceRatio: 0.85,
            scrollbar: false,
            shortSwipes: true,
            speed: 500,
            slidesPerView: 1,
            slidesPerGroup: 1,
            preloadImages: false,
            breakpoints: {
                768: {
                    slidesPerView: 1,
                    slidesPerGroup: 1
                },
                1024: {
                    slidesPerView: 1,
                    slidesPerGroup: 1
                }
            },
            resizeTimeout: 150,
            wrapPrevnext: true,
            onBefore: null,
            onClickPrev: null,
            onClickNext: null,
            onFullscreen: null,
            onInit: null,
            onResize: null,
            onSlide: null,
            onSlideChange: null,
            onSlidePrev: null,
            onSlideStart: null,
            onSlideNext: null,
            onLazyLoaded: null,
            simulateTouch: true,
            spaceBetween: 0
        };

        this.settings = Object.assign({}, settings, options);

        this.$slider = element;
        this.$slidesList = this.$slider.querySelector('[' + this.settings.initAttr + '="slides"]');
        this.$$slides = this.$slidesList.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.sliderDestroy = this.destroy;
        this.resizeTimer = null;

        if (this.$$slides.length > 1) {
            this.initialize();
        } else {
            this.$slider.classList.add('no-slider');
        }
    }

    initialize () {
        let autoplaySettings = false;
        let paginationType = 'bullets';
        let $controls = null;
        let $fullscreenButton = null;
        let $scrollbar = null;
        let $prevButton = null;
        let $nextButton = null;
        let $swiperPagination = null;
        let currentIndex = this.settings.initialSlide;

        const buildSlider = () => {
            const $slidesWrapper = document.createElement('div');
            const amountSlides = this.$$slides.length;

            $slidesWrapper.classList.add('swiper-wrapper');

            for (let i = 0; i < this.$$slides.length; i++) {
                this.$$slides[i].classList.add('swiper-slide');
                this.$$slides[i].setAttribute('data-swiper-slide-index', i);
                $slidesWrapper.appendChild(this.$$slides[i]);
            }

            const $slidesContainer = document.createElement('div');
            $slidesContainer.classList.add('swiper-container');
            this.$slider.classList.add('swiper-length-' + amountSlides);

            $slidesContainer.appendChild($slidesWrapper);

            this.$slidesList.appendChild($slidesContainer);

            return $slidesContainer;
        };

        this.$slidesContainer = buildSlider();

        $controls = document.createElement('div');
        $controls.classList.add('swiper-controls', 'text-to-animate');
        this.$slider.appendChild($controls);

        if (this.settings.scrollbar === true) {
            $scrollbar = document.createElement('div');
            $scrollbar.classList.add('swiper-scrollbar');

            this.$slidesContainer.appendChild($scrollbar);
        }

        if (this.settings.counter === true) {
            paginationType = 'fraction';
        }

        if (this.settings.prevnext === true) {
            $prevButton = document.createElement('div');
            $prevButton.classList.add('swiper-button-prev');
            $prevButton.innerHTML = '<i>prev</i>';
            $prevButton.setAttribute(this.settings.initAttr, 'prev');

            $nextButton = document.createElement('div');
            $nextButton.classList.add('swiper-button-next');
            $nextButton.innerHTML = '<i>next</i>';
            $nextButton.setAttribute(this.settings.initAttr, 'next');

            if (this.settings.wrapPrevnext === true) {
                $controls.appendChild($prevButton);
                $controls.appendChild($nextButton);
            } else {
                this.$slidesList.appendChild($prevButton);
                this.$slidesList.appendChild($nextButton);
            }

            $prevButton.addEventListener('click', () => {
                if (typeof this.settings.onClickPrev === 'function') {
                    this.settings.onClickPrev(this.slider.activeIndex - 1);
                }
            });

            $nextButton.addEventListener('click', () => {
                if (typeof this.settings.onClickNext === 'function') {
                    this.settings.onClickNext(this.slider.activeIndex + 1);
                }
            });
        }

        if (this.settings.fullscreen === true) {
            $fullscreenButton = document.createElement('div');
            $fullscreenButton.classList.add('swiper-button-fullscreen');
            $fullscreenButton.innerHTML = '<i>Fullscreen</i>';
            $fullscreenButton.setAttribute(this.settings.initAttr, 'fullscreen');

            if (this.settings.wrapPrevnext === true) {
                $controls.appendChild($fullscreenButton);

                if (this.settings.prevnext === true) {
                    $controls.appendChild($prevButton);
                    $controls.appendChild($nextButton);
                }
            } else {
                this.$slidesList.appendChild($fullscreenButton);

                if (this.settings.prevnext === true) {
                    this.$slidesList.appendChild($prevButton);
                    this.$slidesList.appendChild($nextButton);
                }
            }
        }

        if (this.settings.indicators === true || this.settings.counter === true) {
            $swiperPagination = document.createElement('div');
            $swiperPagination.classList.add('swiper-pagination');

            if (this.settings.indicatorsInControls === true && this.settings.wrapPrevnext === true) {
                $controls.appendChild($swiperPagination);
            } else {
                this.$slidesList.appendChild($swiperPagination);
            }
        }

        if (this.settings.autoplay !== false) {
            autoplaySettings = {
                delay: this.settings.autoplay,
                disableOnInteraction: this.settings.pauseOnHover
            };
        }

        this.slider = new Swiper(this.$slidesContainer, {
            autoHeight: this.settings.autoHeight,
            autoplay: autoplaySettings,
            breakpoints: this.settings.breakpoints,
            centeredSlides: this.settings.centeredSlides,
            effect: this.settings.effect,
            spaceBetween: this.settings.spaceBetween,
            fadeEffect: {
                crossFade: this.settings.crossfade
            },
            freeMode: this.settings.freeMode,
            freeModeSticky: this.settings.freeModeSticky,
            initialSlide: this.settings.initialSlide,
            lazy: this.settings.lazyLoading,
            loop: this.settings.loop,
            loopedSlides: this.settings.loopedSlides,
            mousewheel: this.settings.mousewheel,
            navigation: {
                nextEl: $nextButton,
                prevEl: $prevButton
            },
            normalizeSlideIndex: true,
            observer: true,
            pagination: {
                clickable: true,
                el: $swiperPagination,
                type: paginationType,
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>' +
                            ' ' + this.settings.fractionText + ' ' +
                            '<span class="' + totalClass + '"></span>';
                }
            },
            preloadImages: this.settings.preloadImages,
            parallax: this.settings.parallax,
            resistanceRatio: this.settings.resistanceRatio,
            roundLengths: true,
            scrollbar: {
                el: $scrollbar,
                draggable: true
            },
            simulateTouch: this.settings.simulateTouch,
            shortSwipes: this.settings.shortSwipes,
            longSwipesRatio: this.settings.longSwipesRatio,
            slidesPerView: this.settings.slidesPerView,
            slidesPerGroup: this.settings.slidesPerGroup,
            speed: this.settings.speed,
            on: {
                init: () => {
                    if (this.settings.calculateHeight === true) {
                        this.calculateContainerHeight();
                    }

                    this.$slidesList.classList.add('swiper-items');

                    if (this.settings.fullscreen === true) {
                        $fullscreenButton.addEventListener('click', () => {
                            this.settings.onFullscreen(currentIndex);
                        });
                    }

                    if (this.settings.indicators === true && this.settings.indicatorsHover === true) {
                        const bulletInterval = window.setInterval(() => {
                            const $$bullets = $swiperPagination.querySelectorAll('span');

                            if ($$bullets.length > 0) {
                                clearInterval(bulletInterval);

                                for (let b = 0; b < $$bullets.length; b++) {
                                    const $bullet = $$bullets[b];

                                    $bullet.addEventListener('mouseenter', () => {
                                        $bullet.click();
                                    });
                                }
                            }
                        }, 100);
                    }

                    if (typeof this.settings.onInit === 'function') {
                        this.settings.onInit(this, this.$slider.querySelector('.swiper-slide-active'), this.settings.initialSlide);
                    }
                },
                slideChangeTransitionEnd: () => {
                    const $current = this.$slider.querySelector('.swiper-slide-active');

                    currentIndex = parseInt($current.getAttribute('data-swiper-slide-index'));

                    if (typeof this.settings.onSlide === 'function') {
                        this.settings.onSlide(this.slider, $current, currentIndex);
                    }
                },
                slideChange: () => {
                    currentIndex = this.slider.activeIndex;
                    const $current = this.$$slides[currentIndex];

                    if (typeof this.settings.onSlideChange === 'function') {
                        this.settings.onSlideChange(this.$slider, this.slider, $current, currentIndex);
                    }
                },
                lazyImageReady: () => {
                    if (typeof this.settings.onLazyLoaded === 'function') {
                        this.settings.onLazyLoaded(this.$slider, this.$slider.querySelector('.swiper-slide-active'));
                    }
                },
                slideChangeTransitionStart: () => {
                    const $current = this.$slider.querySelector('.swiper-slide-active');
                    if (typeof this.settings.onSlideStart === 'function') {
                        this.settings.onSlideStart(this.$slider, this.slider, $current);
                    }
                },
                slidePrevTransitionStart: () => {
                    if (typeof this.settings.onSlidePrev === 'function') {
                        this.settings.onSlidePrev();
                    }
                },
                slideNextTransitionStart: () => {
                    if (typeof this.settings.onSlideNext === 'function') {
                        this.settings.onSlideNext();
                    }
                },
                resize: () => {
                    if (this.settings.calculateHeight === true) {
                        this.calculateContainerHeight(() => {
                            this.slider.update();
                        });
                    } else {
                        clearTimeout(this.resizeTimer);
                        this.resizeTimer = window.setTimeout(() => {
                            this.slider.update();
                        }, 1000);
                    }
                    if (typeof this.settings.onResize === 'function') {
                        this.settings.onResize(this.$slider);
                    }
                }
            }
        });

        this.$controls = $controls;
    }

    calculateContainerHeight (callback) {
        if (this.settings.autoHeight === true) {
            if (typeof callback === 'function') {
                callback();
            }
            return;
        }

        let maxHeight = 0;
        this.$slidesList.style.height = 'auto';

        if (this.settings.equalHeights === true) {
            for (let i = 0; i < this.$$slides.length; i++) {
                const $slide = this.$$slides[i];
                $slide.style.height = 'auto';
            }
        }

        for (let i = 0; i < this.$$slides.length; i++) {
            const $slide = this.$$slides[i];

            if ($slide.offsetHeight > maxHeight) {
                maxHeight = $slide.offsetHeight;
            }
        }

        if (maxHeight > 0) {
            this.$slidesList.style.height = maxHeight + 'px';
        }

        if (this.settings.equalHeights === true) {
            for (let i = 0; i < this.$$slides.length; i++) {
                const $slide = this.$$slides[i];
                if (maxHeight > 0) {
                    $slide.style.height = maxHeight + 'px';
                }
                if (i === this.$$slides.length - 1 && typeof callback === 'function') {
                    callback();
                }
            }
        } else if (typeof callback === 'function') {
            callback();
        }
    }

    sliderPrev () {
        this.slider.slidePrev();
    }

    sliderNext () {
        this.slider.slideNext();
    }

    sliderTo (i) {
        this.slider.slideTo(i);
    }

    destroy () {
        if (typeof this.slider !== 'undefined' && this.slider !== null) {
            this.slider.destroy();

            this.$controls.parentNode.removeChild(this.$controls);

            for (let i = 0; i < this.$$slides.length; i++) {
                const $currentSlide = this.$$slides[i];
                $currentSlide.classList.remove('swiper-slide');
                this.$slidesList.appendChild($currentSlide);
            }

            this.$slider.appendChild(this.$slidesList);
            this.$slidesContainer.parentNode.removeChild(this.$slidesContainer);
            this.$slidesList.style.height = 'auto';
        }
    }
    // @TODO: add, refresh, removeSlides, addSlide, update functions
}

export { Slider };
